import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, Directive, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { UnSubscribable } from '@core/un-subscrible';
import { Subject } from 'rxjs';
import { delay, skip, takeUntil } from 'rxjs/operators';

@Directive({
    selector: 'cdk-virtual-scroll-viewport[eigDynamicHeight]'
})
export class EigVirtualScrollDynamicHeightDirective extends UnSubscribable implements OnInit, AfterViewInit, OnChanges {
    @Input()
    scrollSpacerHeight: number;
    @Input()
    maxHeight: number;
    private readonly itemSize: number;

    constructor(private cdkVirtualScroll: CdkVirtualScrollViewport, private renderer: Renderer2) {
        super();
        this.itemSize = Number(this.cdkVirtualScroll.elementRef.nativeElement.getAttribute('itemSize'));
    }
    ngOnChanges(changes: SimpleChanges): void {

        if (this.scrollSpacerHeight < this.maxHeight) {
            this.renderer.setStyle(
                this.cdkVirtualScroll.elementRef.nativeElement,
                'height',
                `${this.scrollSpacerHeight + 10 * this.cdkVirtualScroll.getDataLength()}px`
            );
        } else {
            this.renderer.setStyle(this.cdkVirtualScroll.elementRef.nativeElement, 'height', `${this.maxHeight}px`);
        }

        if (this.cdkVirtualScroll.getDataLength() === 0) {
            this.renderer.setStyle(this.cdkVirtualScroll.elementRef.nativeElement, 'height', `${this.itemSize + 10}px`);
        }

        this.cdkVirtualScroll.checkViewportSize();
    }
    ngOnInit(): void {}

    ngAfterViewInit(): void {}
}
